export const PERMS = {
    READ: 'equipments.read',
    UPDATE: 'equipments.update',
    DELETE: 'equipments.delete',
    CREATE: 'equipments.create',
    EXPORT: 'equipments.export',
}
